document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tabs');
  const tabLinks = document.querySelectorAll('.tabs__link');
  const tabContents = document.querySelectorAll('.tabs__content');

  function initializeTabs() {
    tabLinks.forEach((link, index) => {
      if (link.classList.contains('is-active')) {
        tabContents[index].closest('.tabs__tab').classList.add('is-active');
      }
    });
  }

  /**
   * handleClick
   * @description Handles click event listeners on each of the links in the
   *   tab navigation. Returns nothing.
   * @param {HTMLElement} link The link to listen for events on
   */
  function handleClick(link) {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      tabContents.forEach(tab => tab.closest('.tabs__tab').classList.remove('is-active'));
      tabLinks.forEach(link => link.classList.remove('is-active'));

      const targetId = link.getAttribute('href');
      const targetContent = document.querySelector(targetId);

      setTimeout(() => {
        if (targetContent) {
          targetContent.closest('.tabs__tab').classList.add('is-active');
        }
        link.classList.add('is-active');
      }, 300);

    });
  }

  tabs.forEach(tab => tab.classList.remove('no-js'));

  initializeTabs();
  tabLinks.forEach(link => handleClick(link));
});